
import { Component, Vue, Mixins } from 'vue-property-decorator';
import StudentRecruiterComponent from '@/components/StudentDashboard/Gains/StudentRecruiterComponent.vue';
import StudentDutyStatusComponent from '@/components/StudentDashboard/Gains/StudentDutyStatusComponent.vue';
import StudentInfoComponent from '../../StudentDashboard/InProcessing/StudentInfoComponent.vue';
import GtcColumnComponent from '../../StudentDashboard/InProcessing/GtcColumnComponent.vue';
import LettersColumnComponent from '../../StudentDashboard/InProcessing/LettersColumnComponent.vue';
import FinalDatesColumnComponent from '../../StudentDashboard/InProcessing/FinalDatesColumnComponent.vue';
import StudentVitalsComponent from '../../StudentDashboard/Gains/StudentVitalsComponent.vue';
import { Student } from '@/models/Entities/Student/Student';
import StudentSelectionFlyoutComponent from '@/components/Flyout/StudentSelectionFlyoutComponent.vue';
import UpdateStudentMixin from '@/mixins/updateStudentMixin';

@Component<InProcessingFlyoutComponent>({
  components: {
    StudentRecruiterComponent,
    StudentDutyStatusComponent,
    StudentInfoComponent,
    GtcColumnComponent,
    LettersColumnComponent,
    FinalDatesColumnComponent,
    StudentVitalsComponent,
    StudentSelectionFlyoutComponent
  }
})
// TODO: check methods are working after students are passed and can render
export default class InProcessingFlyoutComponent extends Mixins(
  UpdateStudentMixin,
  Vue
) {
  students!: Student[];
  show = false;
  activeStudentIndex = 0;

  resolve: () => void = (): void => void 0;
  reject: () => void = (): void => void 0;

  public open(options: Student[]): Promise<void> {
    this.show = true;
    this.students = options;
    return new Promise((resolve) => {
      this.resolve = resolve;
    });
  }

  close(): void {
    this.show = false;
    this.reject();
  }

  handleSelectStudent(index: number): void {
    this.activeStudentIndex = index;
  }

  get activeStudent(): Student {
    return this.students[this.activeStudentIndex];
  }
}
